module.exports = __webpack_public_path__ + "static/media/scanner-beep-triple.1e77cabe.ogg";